<template>
    <app-layout title="Dashboard">
      <template v-slot:sidenav> </template>
  
       <!-- grid start from here -->
       <div class="flex h-full">
    <!-- Sidebar -->
    <div class="bg-white text-black sm:w-52 md:w-52 lg:w-1/5  h-[35.6rem] overflow-y-auto auto border-l-2 border-gray-100">
      <!-- Your sidebar content goes here -->
      <div class="bg-gray-50 ">
        <div class="p-4 flex">
          <jet-nav-icon
         
          href="/interface/chat" class=""
            >
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          </jet-nav-icon>
           
            &nbsp; &nbsp; &nbsp;
            <h4 class="font-medium">Settings</h4>
        </div>
      </div>
      <ul class="my-3">
        <li class="mb-2  mx-3">
            <jet-side-link>
              <div href="#" class="flex items-center py-2 px-3 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                <i class="fa fa-user text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true"></i>
                &nbsp; &nbsp;
               <span class="ms-3 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white">Profile</span>
              </div>
            </jet-side-link>
        </li>
        <li class="mb-2  mx-3">
            <jet-side-link>
              <div href="#" class="flex items-center py-2 px-3 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                <i class="fa fa-users text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true"></i>

                &nbsp; &nbsp;
               <span class="ms-3 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white">Users</span>
              </div>
            </jet-side-link>
        </li>
        <li class="mb-2  mx-3">
            <jet-side-link>
              <div href="#" class="flex items-center py-2 px-3 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                <i class="fa fa-database text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true"></i>

                &nbsp; &nbsp;
               <span class="ms-3 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white">Data</span>
              </div>
            </jet-side-link>
        </li> 
        <li class="mb-2  mx-3">
            <jet-side-link>
              <div href="#" class="flex items-center py-2 px-3 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                <i class="fa fa-phone text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true"></i>

                &nbsp; &nbsp;
               <span class="ms-3 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white">Contact</span>
              </div>
            </jet-side-link>
        </li>
        <li class="mb-2  mx-3">
            <jet-side-link>
              <div href="#" class="flex items-center py-2 px-3 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                <i class="fa fa-clone  text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true"></i>

                &nbsp; &nbsp;
               <span class="ms-3 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white">Role</span>
              </div>
            </jet-side-link>
        </li>
        <li class="mb-2  mx-3">
            <jet-side-link>
              <div href="#" class="flex items-center py-2 px-3 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                <i class="fa fa-file-text text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true"></i>

                &nbsp; &nbsp;
               <span class="ms-3 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white">Template</span>
              </div>
            </jet-side-link>
        </li>
      </ul>
      <!-- Add more items as needed -->
    </div>

    <!-- Main Content -->
    <div class="flex-1 px-5 py-3">
      <!-- Your main content goes here -->
      <h4 class=" font-semibold ">Profile</h4>
      <p>Update your profile here</p>
      <hr>
       <!-- Name section start from here -->
        <div class="flex justify-between my-4">
          <div class="font-semibold">Name</div>
          
          <div>
          <div class="mb-2">
            <label for="username" class="block text-sm font-semibold text-gray-600">First Name</label>
            <input
              type="text"
              id="username"
              class="p-2 border border-gray-300 rounded-md w-80 bg-transparent"
            />
          </div>

          <div class="mb-2">
            <label for="username" class="block text-sm font-semibold text-gray-600">Last Name</label>
            <input
              type="text"
              id="username"
              class="p-2 border border-gray-300 rounded-md w-80 bg-transparent"
            />
          </div>
        </div>

        </div>
       <!-- Name section end -->

       <hr>
       <!-- About section start from here -->
        <div class="flex justify-between my-4">
          <div class="font-semibold">About</div> 
          <div>
          <div class="mb-2">
            <label for="username" class="block text-sm font-semibold text-gray-600">Email</label>
            <input
              type="text"
              id="username"
              class="p-2 border border-gray-300 rounded-md w-80 bg-transparent"
            />
          </div>

          <div class="mb-2">
            <label for="username" class="block text-sm font-semibold text-gray-600">Phone No.</label>
            <input
              type="text"
              id="username"
              class="p-2 border border-gray-300 rounded-md w-80 bg-transparent"
            />
          </div>
        </div>
        </div>
       <!-- Name section end -->
    </div>
  </div>
       <!-- grid end here -->
    
     
    </app-layout>
  </template>
  
  <script>
  import AppLayout from "@/Layouts/AppLayout.vue";
  import NavBar from "@/Layouts/NavBar.vue";
  import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import JetSideLink from "@/Jetstream/SideLink.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import JetNavIcon from "@/Jetstream/NavIcon";
  
  export default {
    props: {
      selectedId: String,
      selectedType: String,
    },
    components: {
      AppLayout,
      NavBar,
      JetResponsiveNavLink,
      JetSideLink,
      JetDropdownLink,
      JetNavIcon
    },
    data() {
      return {
      
      };
    },
  
     methods: {
  
    },
    mounted() {
   
  
    },
  };
  </script>
  
  <style>
 h4 {
  margin-bottom: 0.1rem;
  }
  p{
    margin-bottom: 0.01rem;
  }
  hr{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  }
  /* .pads{
    padding-top: -2px !important;
  } */
  
  </style>